import { CourseAreaApi } from "@/api";

export async function getAll() {
  const { data } = await CourseAreaApi.getAll();
  return data;
}
